export default __webpack_public_path__ + "static/media/service1.3e84ec57.jpg";